import { accountEntityName } from '../../../../../backend/features/accounts/shared/entities/accountTypes';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { groupEntityName } from './groupEntityTypes';
export const groupAccountMapEntityName = 'groupAccountMap';
export const groupAccountMapColumns = defineColumns({
    groupId: {
        type: 'foreign-key',
        entity: groupEntityName,
        onDeleteCascade: true,
    },
    accountId: {
        type: 'foreign-key',
        entity: accountEntityName,
        onDeleteCascade: true,
    },
    unique: {
        type: 'string-required',
        index: 'unique',
    },
});
